<template>
	<span>{{ saldoCPInfo.saldoCampanhaPontos }}</span>
</template>
<script>
export default
{
	name: 'saldoCPCliente',
	props: { cpsaldocliente : String },
	data() { return { saldoCPInfo: [], root: ROOT_URL, app: APP_URL } },
	methods: {
		loadInfo()
		{
			if (this.cpsaldocliente != 'loadFromApi')
			{
				this.saldoCPInfo = { saldoCampanhaPontos: this.cpsaldocliente };
			}
			else
			{
				this.axios.get(API_URL + '/campanha-pontos/saldo-pontos-cliente-api').then((dadosSaldoCPInfo) => { this.saldoCPInfo = dadosSaldoCPInfo.data; });
			}
		}
	},
	mounted() {
		this.loadInfo();
    	this.$root.$on('updateSaldoCPCliente', (strValorSaldo) => { this.saldoCPInfo = { saldoCampanhaPontos: strValorSaldo }; });
	}
}
</script>